export const GET_MY_REDEEM_AGENCY_PANEL = "GET_MY_REDEEM_AGENCY_PANEL";

export const GET_PERTICULAR_AGENCY_USER_REDEEM_REQUEST = "GET_PERTICULAR_AGENCY_USER_REDEEM_REQUEST"

export const NEW_REDEEM_CREATE = "NEW_REDEEM_CREATE";

export const OPEN_NEW_REDEEM_DIALOG = "OPEN_NEW_REDEEM_DIALOG";
export const CLOSE_NEW_REDEEM_DIALOG = "CLOSE_NEW_REDEEM_DIALOG";